import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const SalarysheetEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		payid: yup.string().required().label($t('payid')),
		empcode: yup.string().required().label($t('empcode')),
		generatedate: yup.string().required().label($t('generatedate')),
		salarymonth: yup.string().required().label($t('salarymonth')),
		salaryyear: yup.number().required().label($t('salaryyear')),
		amount: yup.string().required().label($t('amount')),
		paytype: yup.string().required().label($t('paytype'))
	});
	// form default values
	const formDefaultValues = {
		payid: '', 
		empcode: '', 
		generatedate: "(getutcdate())", 
		salarymonth: '', 
		salaryyear: '', 
		amount: '', 
		paytype: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/salarysheet`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="SalarysheetEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editSalarysheet')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('payid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/payid_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="payid"     optionLabel="label" optionValue="value" value={formik.values.payid} onChange={formik.handleChange} options={response} label={$t('payid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.payid)}   />
                                                    <ErrorMessage name="payid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('generatedate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="generatedate" showButtonBar className={inputClassName(formik?.errors?.generatedate)} dateFormat="yy-mm-dd" value={formik.values.generatedate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="generatedate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('salarymonth')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="salarymonth"     optionLabel="label" optionValue="value" value={formik.values.salarymonth} onChange={formik.handleChange} options={app.menus.salarymonth} label={$t('salarymonth')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.salarymonth)}   />
                                                <ErrorMessage name="salarymonth" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('salaryyear')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="salaryyear"  onChange={formik.handleChange}  value={formik.values.salaryyear}   label={$t('salaryyear')} type="number" placeholder={$t('enterSalaryyear')}  min={0}  step="any"    className={inputClassName(formik?.errors?.salaryyear)} />
                                                <ErrorMessage name="salaryyear" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label={$t('amount')} type="text" placeholder={$t('enterAmount')}        className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paytype')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paytype"  onChange={formik.handleChange}  value={formik.values.paytype}   label={$t('paytype')} type="text" placeholder={$t('enterPaytype')}        className={inputClassName(formik?.errors?.paytype)} />
                                                <ErrorMessage name="paytype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
SalarysheetEditPage.defaultProps = {
	primaryKey: 'salaryid',
	pageName: 'salarysheet',
	apiPath: 'salarysheet/edit',
	routeName: 'salarysheetedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SalarysheetEditPage;
